<template>
	<div style="width:90%;">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="仓库:">
						<el-select filterable v-model="searchInfo.warehouseId" style="width: 200px" placeholder="请选择" clear 
						@change="warehouseFocus">
							<el-option v-for="it in warehouseList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户:">
						<el-select filterable v-model="searchInfo.customerId"  placeholder="请选择" clear 
                        style="width: 220px">
							<el-option v-for="it in userList" :key="it.id" :value="it.id"
								:label="it.customerName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item  label="入库类型:">
						<el-select filterable v-model="searchInfo.orderType" placeholder="请选择" clear 
						style="width: 120px">
							<el-option v-for="it in typeList" :key="it.id" :value="it.typeKey"
								:label="it.typeName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态:">
						<el-select filterable v-model="searchInfo.status"  placeholder="请选择" clear 
                        style="width: 120px">
							<el-option  :key="0" :value="0" label="制单中"></el-option>
							<el-option  :key="1" :value="1" label="入库中"></el-option>
							<el-option  :key="2" :value="2" label="已完成"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="入库日期:">
						<!-- <el-date-picker 
							v-model="searchInfo.storageTime" value-format="yyyy-MM-dd"
							type="date" 
							placeholder="选择日期"> 
						</el-date-picker> -->
						<el-date-picker v-model="timerArr" value-format="yyyy-MM-dd HH:mm:ss"
							type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
							:default-time="['00:00:00', '23:59:59']">
						</el-date-picker>
					</el-form-item>
                    <el-form-item label="客户订单号:">
						<el-input type="text" style="width: 220px; " placeholder="客户订单号"  v-model="searchInfo.customerOrderCode"
							auto-complete="off" />
					</el-form-item>
					 <el-form-item label="入库单号:" >
						<el-input type="text" style="width: 220px; " placeholder="请输入入库单号"  v-model="searchInfo.orderCode"
							auto-complete="off" />
					</el-form-item>
                  
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>

					<el-button type="primary" @click="bePutInStorage">一键入库中</el-button>
					<el-button type="primary" @click="customsDeclaration">一键关单</el-button>

					<el-button type="primary" @click="printMultiterm">一键打印</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%" border @selection-change="handleSelectionChange">
			<el-table-column
			    type="selection" align="center"
			    width="40">
			</el-table-column>
			<!-- :selectable="checkSelectable" -->
			 <!-- @selection-change="handleSelectionChange" -->
			<el-table-column prop="warehouseName" label="仓库" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
            <!-- <el-table-column prop="warehouseAreaName" label="库区" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column  prop="warehouseLocationName" label="库位" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="orderTypeName" label="入库类型" align="center" width="85" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="orderCode" label="入库单号" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="customerName" label="客户名称" align="center" width="200" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="csource" label="供货单位" align="center" width="150"  :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="customerOrderCode" label="客户订单号" align="center" width="170" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="carNo" label="车牌号码" align="center" width="100" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="volume" label="体积(m³)" align="center" width="100" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="weight" label="重量(kg)" align="center" width="100" :show-overflow-tooltip="true">
			</el-table-column>
            <!-- <el-table-column prop="warehouseLocationLength" label="库位长度(m)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="warehouseLocationWidth" label="库位宽度(m)" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->

		    <el-table-column prop="status" label="状态" align="center" width="100" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0" style="color:#409EFF;font-weight: bold;">制单中</span>
					<span v-if="scope.row.status==1" style="color:#F7BA2A;font-weight: bold;">入库中</span>
					<span v-if="scope.row.status==2" style="color:#13CE66;font-weight: bold;">已完成</span>
				</template>
			</el-table-column>
			<el-table-column prop="memo" label="备注" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="receiver" label="收货人"  align="center" width="150" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="stevedore" label="装卸组" align="center" width="150" :formatter="changeNull">
			</el-table-column>
            <el-table-column prop="" label="作业时间" align="center" width="150" :show-overflow-tooltip="true">
                <template slot-scope="scope">
					<span >{{ scope.row.beginDatetime }}</span>
                    -
                    <span >{{ scope.row.endDatetime }}</span>
                </template>
			</el-table-column>
			<el-table-column prop="storageTime" label="入库日期"  align="center" width="170" >
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间"  align="center" width="170" >
			</el-table-column>
			<el-table-column prop="createBy" label="制单人"  align="center" width="100" >
			</el-table-column>
			<el-table-column prop="printTimes" label="打印次数"  align="center" width="80" >
			</el-table-column>
            <el-table-column prop="lastPrintDatetime" label="最后一次打印时间"  align="center" width="250" :formatter="changeNull">
			</el-table-column>

			<el-table-column fixed="right" label="操作" align="center" :show-overflow-tooltip="true" width="200px">
				<template slot-scope="scope">
					<el-button size="small" type="text" 
					@click="editialogVisible(scope.row.id)" v-if="scope.row.status!=2">编辑</el-button>
					<!-- <el-button size="small" type="text" v-if="scope.row.status==2" 
					@click="examine(scope.row.id)">查看</el-button> -->
					<el-button size="small" type="text" 
					@click="editialogVisible(scope.row.id)" v-if="scope.row.status==2">查看</el-button>

					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					<el-button size="small" type="text" style="color:red;" @click="toBlockUp(scope.row.id)"  
					v-if="scope.row.status==0">入库中</el-button> 

					<el-button size="small" type="text" style="color:red;"  @click="toStartUsing(scope.row.id)"
					v-if="scope.row.status==1">关单</el-button> 
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		

		<div class="printBox">
			<div id="printMe" ref="printContent" class="content" >
			<div v-for="(item,index) in printInfoAndList" :key="index" class="printMeListBox">
				<div style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
					入库单通知单
				</div>
				<div style="height:10px;"></div>
				<el-form v-model="item.printInfo">
					<div style="display: flex;justify-content: space-between;height:30px;">
						<el-form-item label="仓库:" style="width: 25%;">
							<span>{{item.printInfo.warehouseName}}</span>
						</el-form-item>
						<el-form-item  label="订单类型:" style="width: 25%;">
							<span>{{item.printInfo.orderTypeName}}</span>
						</el-form-item>
						<el-form-item label="客户:" style="width: 25%;">
							<span>{{item.printInfo.customerName}}</span>
						</el-form-item>
						<el-form-item label="入库单号:" style="width: 25%;">
							<span>{{item.printInfo.orderCode}}</span>
						</el-form-item>

					</div>
					<div style="display: flex;justify-content: space-between;height:30px;">
						<el-form-item label="供货单位:" style="width: 45%;">
							<span>{{item.printInfo.csource}}</span>
						</el-form-item>
						<el-form-item label="客户订单号:" style="width: 30%;">
							<span>{{item.printInfo.customerOrderCode}}</span>
						</el-form-item>
						<el-form-item label="车牌号码:" style="width: 25%;">
							<span>{{item.printInfo.carNo}}</span>
						</el-form-item>
					</div>
					<div style="display: flex;height:30px;justify-content: space-between;">
						<el-form-item label="备注:" >
							<span>{{item.printInfo.memo}}</span>
						</el-form-item>
						<el-form-item label="打印时间:" style="text-align: right;">
							<span class="pintTimeID"></span>
							<span style="padding-left:10px;">第</span>
							<span style="padding:0 5px;">{{ item.printInfo.printTimes+1 }}</span>
							<span>次打印</span>
						</el-form-item>   
					</div>
				
					<div style="width: auto;position: relative;">
						
						<table  cellspacing="0" cellpadding="0" border="1" style="background-color: #fff;">
							
							<thead>
								
								<tr>
									
									<td>商品编号</td>
									<td style="width:300px;">商品名称</td>
									<td>商品状态</td>
									<td>批次</td>
									<td style="width:60px;">计划数</td>
									<td style="width:85px;">计划数EA</td>
									<td style="width:60px;">实收</td>
									<td>库位</td>
									<td>备注</td>
									
								</tr>
							</thead>
							<tbody >
								<tr v-for="(items, index) in item.printDataList" :key="index" >
									<td>{{ items.pdtCode }}</td>
									<td>{{ items.pdtName }}</td>
									<td>{{ items.goodsStatusName }}</td>
									<td>{{ items.batchNo }}</td>
									<td>{{ items.num }}箱</td>
									<td>{{ items.eaNum }}{{items.unitName}}</td>
									<td></td>
									<td>{{ items.warehouseLocationName }}</td>
									<td>{{ items.remark }}</td>
								</tr>
								<tr>
									<td>数量合计</td>
									<td></td>
									<td></td>
									<td></td>
									<td>{{ item.printInfo.numTotal }}箱</td>
									<td>{{ item.printInfo.eaNumTotal }}</td>
									<td></td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
							
						</table>
						
					</div>
					<div style="display: flex;"  class="print-footer">
							<el-form-item label="制单人:" style="width: 25%;">
								<span>{{ item.printInfo.createBy }}</span>
							</el-form-item>
							<el-form-item label="收货人:" style="width: 25%;">
								<span>{{ item.printInfo.receiver }}</span>
							</el-form-item>
							<el-form-item label="装卸组:" style="width: 25%;">
								<span>{{ item.printInfo.stevedore }}</span>
							</el-form-item>
							<el-form-item label="作业时间:" style="width: 25%;">
								<span>{{ item.printInfo.beginDatetime }}</span> - <span>{{ item.printInfo.endDatetime }}</span>
							</el-form-item>
							<el-form-item label="" style="width: 25%;">
								<span>第1页/共1页</span>
							</el-form-item>
							
					</div>
				</el-form>
				
			</div>
			
			</div>
		</div>

		<el-dialog title="提示" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" center>
			<div>
				确定要
				<span style="color:#F56C6C;font-weight: bold;">{{poupText}} </span>
				操作
				<span style="color:#F56C6C;font-weight: bold;">{{tableSelectID.length }}</span>
				条数据？
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" v-print="printObj" ref="printBtn" v-if="poupText=='一键打印'">打 印</el-button>
				<el-button type="primary" @click="bePutInStorageSubmit" :loading='loadingTwo' v-if="poupText=='一键入库中'">确 定</el-button>
				<el-button type="primary" @click="customsDeclarationSubmit" :loading='loadingThree' v-if="poupText=='一键入关单'">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import moment from 'moment'; 
	export default {
		data() {
			let that = this
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				searchInfo: {},
				timerArr: [],
				typeList: [],
				userList: [],
				sliderlist:{},
				storeGoodsInfo: {
					showStatus:true
				},
				dialogVisible: false,
				poupText: '',
				poupTitle: '',
				loadingTwo: false,
				loadingThree: false,
                addLoading: false,
                editLoading: false,
                
                warehouseId: '',
                districtId: '',
                locationList: [],
				warehouseList: [],
				
				tableSelectID: [], //表格多选数组
				printInfoAndList: [],
				// printInfo: {},
				// printDataList: [],
				pintTime: '',
				printObj : {
					id: 'printMe',//id
					popTitle: "",//自定义设置标题
					extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
					preview: false, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
					previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
					previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
					zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）   
					previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
					previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
					beforeOpenCallback() {}, // 开启打印前的回调事件
					openCallback() {}, // 调用打印之后的回调事件
					closeCallback() {
						that.dialogVisible = false;
						that.findPmsUnit();
					}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
					clickMounted() { 
						// console.log('点击v-print绑定的按钮了！')
						let box = document.getElementsByClassName('pintTimeID');
						// console.log('233--', box)
						// innerHTML = moment().format('YYYY-MM-DD HH:mm:ss');
						for(let i=0;i<box.length;i++){
							box[i].innerHTML = moment().format('YYYY-MM-DD HH:mm:ss');
						}
						
						that.$api.warehouseWarrantPrintList({
							arr : that.tableSelectID.join(',')
						}).then(res=>{
							if(res.state = 'success'){
								let info = JSON.parse(res.data.content);
								// that.printInfo.lastPrintDatetime = info.lastPrintDatetime;
								// that.printInfo.printTimes = info.printTimes;
								// console.log('1111--', res.data)
								// console.log('122--', JSON.parse(res.data.content))
							}
						})
					}, //点击v-print绑定的按钮了！
					url: '',
					standard: '',
					extraCss: '',
				},

			}
		},
		methods: {
			//导出
			print() {
			      // 使用 this.$hiprint 方法调用 HiPrint 插件
			      this.$hiprint.print({
			        template: '<h1>Hello, HiPrint!</h1>',
			        styles: `
			          h1 {
			            color: red;
			          }
			        `
			      })
			    },
			downloadFile() {
				let data = {
					warehouseId: this.searchInfo.warehouseId, //仓库
					orderType: this.searchInfo.orderType, //订单类型
					customerId: this.searchInfo.customerId, //客户
					status: this.searchInfo.status, //订单状态
					// storageTime: this.searchInfo.storageTime, //入库时间
					startTime: this.timerArr ? this.timerArr[0] : "",
					endTime: this.timerArr ? this.timerArr[1] : "",
					customerOrderCode: this.searchInfo.customerOrderCode, //客户订单号
					orderCode: this.searchInfo.orderCode, //入库单号
				};
				// console.log(data);
				this.$api.wmsInOrderListExportExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "入库单列表" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
            changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()

			},
			empty() { //清空
				this.searchInfo = {}
				this.timerArr = [];
			},
			addDialogClose() {
				this.storeGoodsInfo = {}
			},
			findPmsUnit() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					warehouseId: this.searchInfo.warehouseId, //仓库
					orderType: this.searchInfo.orderType, //订单类型
					customerId: this.searchInfo.customerId, //客户
					status: this.searchInfo.status, //订单状态
					// storageTime: this.searchInfo.storageTime, //入库时间
					startTime: this.timerArr ? this.timerArr[0] : "",
					endTime: this.timerArr ? this.timerArr[1] : "",
					customerOrderCode: this.searchInfo.customerOrderCode, //客户订单号
					orderCode: this.searchInfo.orderCode, //入库单号
				}
				this.$api.getWarehouseWarrantList(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

            },
            warehouseFocus(e){
                this.$api.getDistrictListNoParameter({
                    warehouseId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
			},
			bePutInStorage(){ //一键入库中
				if(this.tableSelectID.length==0){
					this.$message.error("未选择数据");
					return
				}
				this.poupText = '一键入库中';
				this.dialogVisible = true;
			},
			bePutInStorageSubmit(){ //提示框的确认
				this.loadingTwo = true;
				this.$api.oneClickInTheLibrary({
					arr: this.tableSelectID.join(',')
				}).then(res=>{
					if (res.state == 'success') {
						this.$message.success(res.message);
						this.findPmsUnit();
						this.dialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.loadingTwo = false;
				})
			},
			customsDeclaration(){ //一键关单
				if(this.tableSelectID.length==0){
					this.$message.error("未选择数据");
					return
				}
				this.poupText = '一键入关单';
				this.dialogVisible = true;
			},
			customsDeclarationSubmit(){ //提示框的确认
				this.loadingThree = true;
				this.$api.oneClickOrder({
					arr: this.tableSelectID.join(',')
				}).then(res=>{
					if (res.state == 'success') {
						this.$message.success(res.message);
						this.findPmsUnit();
						this.dialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.loadingThree = false;
				})
			},
			printMultiterm(){ //页面上的打印按钮
				if(this.tableSelectID.length==0){
					this.$message.error("未选择数据");
					return
				}
				this.poupText = '一键打印';
				this.dialogVisible = true;
				let arrList = []
				this.$api.getWarehouseWarrantInfoByIDList({
					arr: this.tableSelectID.join(',')
				}).then(res=>{
					// console.log('连打数据---', res.data)
					res.data.forEach(it=>{
						let numTol = 0;
						let eaNumTol = 0;
						let qtyReceivedTol = 0;
						it.children.forEach(i=>{
							numTol = numTol+i.num
							eaNumTol = eaNumTol+i.eaNum
							qtyReceivedTol = qtyReceivedTol+i.qtyReceived
						})
						it.numTotal = numTol;
						it.eaNumTotal = eaNumTol;
						it.qtyReceivedTotal = qtyReceivedTol;
						arrList.push({
							printInfo: it,
							printDataList: it.children
						})
					})
				})

				// this.tableSelectID.forEach((it)=>{
				// 	this.$api.getWarehouseWarrantInfoByID(it).then(res=>{
				// 		// res.data=JSON.parse(this.$decrypt(res.data)).data
				// 		// this.printInfo = res.data;
				// 		// this.printDataList = res.data.children;
				// 		arr.push({
				// 			printInfo: res.data,
				// 			printDataList: res.data.children
				// 		})
				// 	})
				// })

				this.printInfoAndList = arrList;
				// console.log('连打数据---', arrList)
			},
			handleClose(){
				this.dialogVisible = false;
			},
			handleSelectionChange(e){
				const wclist=[]
				// console.log(e);
				e.map(item=>{
					wclist.push(item.id)
				})
				this.tableSelectID = wclist
				// console.log('选择的数据--',this.tableSelectID);
			},
			checkSelectable(row) {
			  return row.status==1
			},
			
			next(item,i,id) {
				if (this.$route.path != item.routePath) {
					if(i==1){
						this.$router.push(item.routePath)
					}else{
						this.$router.push({
							path:item.routePath,
							query:{
												     
									     id:id,
								}
							})
						
					}
				
				}
				if(JSON.stringify(this.$store.state.openTab).includes(item.routePath)){
					this.$store.commit('setactiveindex',item.routePath)
				}else{
					this.$store.commit('addtabs',item)
					this.$store.commit('setactiveindex',item.routePath)
						
				}
			},
			// 新增
			addCarousel() {
				let url='/warehouseBill/enterModify'
				this.$api.findByManageUserIdManageFunction().then((res) => {
					if (res.state == 'success') {
						
						res.data.forEach(item => {
						    item.manageFunctionList.forEach(i => {
						        if (i.routePath === url) {
						          this.next(i,'1')
						        }
						    });
						});
					}
				})
				// this.$router.push({
				//    	path: 'enterModify'
				// })
			},
			// 编辑
			editialogVisible(e) {
				let url='/warehouseBill/enterModify'
							
				this.$api.findByManageUserIdManageFunction().then((res) => {
					if (res.state == 'success') {
						
						res.data.forEach(item => {
						    item.manageFunctionList.forEach(i => {
						        if (i.routePath === url) {
						          this.next(i,'2',e)
						        }
						    });
						});
					}
				})
			},
			examine(e) { //查看
				this.$router.push({
				   	path: 'print',
					query:{
					    id: e, 
					}
				})
			},
			toDelete(e) { //删除
				// console.log(e)
				var str = "此操作将删除该入库单, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.delWarehouseWarrantInfoByID(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 入库
			toBlockUp(e) {
				// console.log(e)
				var str = "此操作将入库, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.warehouseWarrantUpdateStatus(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 关单
			toStartUsing(e) {
				// console.log(e)
				var str = "此操作将关单, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.warehouseWarrantUpdateStatus(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
            },
            getWarehouseLis(){
                this.$api.getWarehouseListNoParameter({
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.warehouseList = res.data
					}
				})
			},
			getPrintInfo(){
				// printInfoAndList
				this.$api.getWarehouseWarrantInfoByID(id).then(res=>{
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					this.printInfo = res.data;
					this.printDataList = res.data.children;
				})
			},
		},
		created() {
			
			this.findPmsUnit()
			this.getWarehouseLis()
			this.$api.orderlist({
				position: '入库单'
			}).then(res => {
                // console.log('入库单---', res.data)
				this.typeList = res.data
			})
			this.$api.findcusomer(this.$encrypt({})).then(res => { //客户
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.userList = res.data
			})
		}
	}
</script>

<style>
.el-form-item__content{
	margin: 0 !important;
}
.printBox{
		display: none;
		margin: 0 !important;
	}
</style>
<style media="print" lang="less">
	@page {
	    size:  241mm 159.5mm !important;
		margin: 0 !important;
	}
	.content{   
		// margin: 20px !important;
		table {
			font-family: Arial, sans-serif;
			font-size: 14px;
			background-color: #f0f2f5;
			border-collapse: collapse;
			color: #454545;
			table-layout: auto;
			width: 100%;
			text-align: center;
			border-bottom-width: 1px;
			border-bottom-style: solid;
			border-bottom-color: #dadcde;
			thead {
				border-top-width: 1px;
				border-top-style: solid;
				border-top-color: #dadcde;
				line-height: 40px;
				font-weight: bold;
				color: #454c70;
			}
			tr {
				border-top-width: 1px;
				border-top-style: solid;
				border-top-color: #dadcde;
				line-height: 23px;
			}
			td{
				padding: 5px 10px;
				font-size: 14px;
				font-family: Verdana;
				width: 100px;
				word-break: break-all; // 元素换行
			}
			// 斑马纹效果stripe
			tr:nth-child(even) {
				background: #F5F7F9;
			}
			tr:nth-child(odd) {
				background: #FFF;
			}
		}

	}
  
    

    @media print {
		
		.printBox{
			display: block;
			
		}
        html {
            background-color: #ffffff;
            height: auto;
            margin: 0px !important;
            zoom: 89%;
        }
        // .content {
        //     transform: scale(0.95); /* 设置缩放比例 */
        //     transform-origin: top left; /* 确保从左上角开始缩放 */
        // }
        body {
            border: solid 1px #ffffff;
            // margin: 10mm 15mm 10mm 15mm;
            margin: 0 !important;
            padding: 0 !important;
        }
        /deep/ table {
            table-layout: auto !important;
        }
        /deep/ #pagetable table{
            table-layout: fixed !important;
        }
        .el-table__header-wrapper .el-table__header {
            width: 100% !important;
            border: solid 1px #f2f2f2;
        }
        .el-table__body-wrapper .el-table__body {
            width: 100% !important;
        }
        #pagetable table {
            table-layout: fixed !important;
		}
		.printMeListBox{
			min-height:300px;
			page-break-after: always;
			position: relative;
			.print-footer{
				position: absolute;
				bottom: 0;
				left: 0;
				width: 100%;
				display: flex;
			}
		}
		
	}
	.client-name{
		text-align: center;
	}
</style>